import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useIsAuthenticate from '../../hook/useIsAuthentificated';
import { useDispatch } from 'react-redux';
import { setAccessToken, setRefreshToken, setUserData } from '../../redux/features/userSliceWithTokenValidation';
import { CLIENT_DASHBOARDS, CLIENT_DASHBOARDS_DASHBOARD } from '../../Routes/navigation/navigationPaths';
import Loader from '../../components/Utils/Loader';

const BakeliCallback = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const { slug } = useParams();
  const isAuthenticated = useIsAuthenticate();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // On page load, we take "search" parameters 
  // and proxy them to /api/auth/callback on our Laravel API
  useEffect(() => {

    fetch(`https://api-work.bakeli.tech/api/bakeli/auth/callback${location.search}`, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setLoading(false);
        if (data) {
                dispatch(setUserData(data.user));
                dispatch(setAccessToken(data.access_token));
                dispatch(setRefreshToken(data.refresh_token));
                sessionStorage.setItem("isAuthentificated", isAuthenticated);
                navigate(
                  slug
                    ? `/${slug}`
                    : `/${CLIENT_DASHBOARDS}${CLIENT_DASHBOARDS_DASHBOARD}`
                );
        }
        setData(data);
      });
  }, []);

  if (loading) {
    return <DisplayLoading />
  } else {
    return <DisplayData data={data} />
  }
}

function DisplayLoading() {
  return <div className="flex flex-col justify-center items-center h-[100vh]">
    <Loader color="#030303"size={24} />
    <h1 className='text-4xl mt-2'>En cours de redirection</h1>
  </div>;
}

function DisplayData(data) {
  return (
    <div>
      <samp>{JSON.stringify(data, null, 2)}</samp>
    </div>
  );
}

export default BakeliCallback